export default "__VITE_ASSET__75242705__"